module.exports = require('./getQueriesFromApps')
